import {
  TextField,
  TextFieldInput,
  TextFieldLabel,
} from "@hireart/component-library";
import clsx from "clsx";
import PropTypes from "prop-types";

const getPlaceholder = (isReadOnly) =>
  isReadOnly ? "No reference number" : "Enter reference number...";

export const ReferenceNumberInput = ({
  value,
  isReadOnly,
  onReferenceNumberChange,
  id,
}) => {
  return (
    <div>
      <TextField isOptional isDisabled={isReadOnly}>
        <TextFieldLabel htmlFor={id} isUnstyled>
          Reference Number
        </TextFieldLabel>
        <TextFieldInput
          id={id}
          className={clsx(isReadOnly && "cursor-not-allowed bg-neutral-20")}
          placeholder={getPlaceholder(isReadOnly)}
          value={value || ""}
          onChange={(e) => onReferenceNumberChange?.(e.target.value)}
          onFocus={(e) => e.target.disabled || e.target.select()}
          disabled={isReadOnly}
          size="md"
        />
        {!isReadOnly && <p className="body-3 text-neutral-60">Example 12345</p>}
      </TextField>
    </div>
  );
};

ReferenceNumberInput.defaultProps = {
  isReadOnly: false,
  id: "reference-number",
};

ReferenceNumberInput.propTypes = {
  value: PropTypes.string,
  isReadOnly: PropTypes.bool,
  onReferenceNumberChange: PropTypes.func,
  id: PropTypes.string,
};
